/* tslint:disable */
/* eslint-disable */
/**
 * HR Recruiter API — Statistics Page
 * API для страницы статистики HR Recruiter. Специально разработан для компонента StatisticsPage.tsx.  ## Что нужно для страницы: 1. Статистические карточки: всего кандидатов, средний балл, активные вакансии 2. Распределение по статусам: успешный, в процессе, провал 3. График активности: кандидаты, интервью, заявки по дням (неделя/месяц) 4. Эффективность рекрутеров: объем, завершено, успешность, качество, в работе 5. Таблица собеседований: кандидат, вакансия, рекрутер, оценка, статус, дата  ## Типы статистики: - `overview` - общая статистика для карточек - `activity` - данные для графика активности - `recruiters` - эффективность рекрутеров - `interviews` - детальная таблица собеседований 
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: support@hr-recruiter.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * Роль пользователя (Account.Role)
 * @export
 * @enum {string}
 */

export const AccountRoleEnum = {
    ADMIN: 'ADMIN',
    RECRUITER: 'RECRUITER'
} as const;

export type AccountRoleEnum = typeof AccountRoleEnum[keyof typeof AccountRoleEnum];


/**
 * 
 * @export
 * @interface ActivityByDay
 */
export interface ActivityByDay {
    /**
     * Дата в формате YYYY-MM-DD
     * @type {string}
     * @memberof ActivityByDay
     */
    'date': string;
    /**
     * Количество новых кандидатов (уникальных email) за день
     * @type {number}
     * @memberof ActivityByDay
     */
    'candidates': number;
    /**
     * Количество начатых собеседований (startedAt) за день
     * @type {number}
     * @memberof ActivityByDay
     */
    'interviews': number;
    /**
     * Количество созданных собеседований (createdAt) за день
     * @type {number}
     * @memberof ActivityByDay
     */
    'applications': number;
    /**
     * Количество завершенных собеседований (finishedAt) за день
     * @type {number}
     * @memberof ActivityByDay
     */
    'completedInterviews'?: number;
    /**
     * Количество успешных собеседований за день
     * @type {number}
     * @memberof ActivityByDay
     */
    'successfulInterviews'?: number;
}
/**
 * Стандартный ответ об ошибке
 * @export
 * @interface ErrorResponse
 */
export interface ErrorResponse {
    /**
     * Сообщение об ошибке
     * @type {string}
     * @memberof ErrorResponse
     */
    'message': string;
    /**
     * Список ошибок валидации
     * @type {Array<string>}
     * @memberof ErrorResponse
     */
    'errors'?: Array<string>;
}
/**
 * 
 * @export
 * @interface InterviewDetailItem
 */
export interface InterviewDetailItem {
    /**
     * ID собеседования
     * @type {number}
     * @memberof InterviewDetailItem
     */
    'id': number;
    /**
     * Полное имя кандидата (firstName + lastName)
     * @type {string}
     * @memberof InterviewDetailItem
     */
    'candidateName': string;
    /**
     * Email кандидата
     * @type {string}
     * @memberof InterviewDetailItem
     */
    'candidateEmail': string;
    /**
     * Телефон кандидата (заполняется для live-кандидатов из ai-recruiter)
     * @type {string}
     * @memberof InterviewDetailItem
     */
    'candidatePhone'?: string;
    /**
     * Название позиции (Position.title)
     * @type {string}
     * @memberof InterviewDetailItem
     */
    'position': string;
    /**
     * Имя рекрутера (Account.firstName + lastName)
     * @type {string}
     * @memberof InterviewDetailItem
     */
    'recruiter': string;
    /**
     * Оценка ИИ (aiScore, 0-10)
     * @type {number}
     * @memberof InterviewDetailItem
     */
    'rating': number;
    /**
     * 
     * @type {StatisticsInterviewStatusEnum}
     * @memberof InterviewDetailItem
     */
    'status': StatisticsInterviewStatusEnum;
    /**
     * Дата создания собеседования (createdAt)
     * @type {string}
     * @memberof InterviewDetailItem
     */
    'date': string;
    /**
     * Время начала собеседования
     * @type {string}
     * @memberof InterviewDetailItem
     */
    'startedAt'?: string;
    /**
     * Время завершения собеседования
     * @type {string}
     * @memberof InterviewDetailItem
     */
    'finishedAt'?: string;
    /**
     * Подтвержден ли email кандидата
     * @type {boolean}
     * @memberof InterviewDetailItem
     */
    'emailVerified'?: boolean;
    /**
     * Тип интервью — живое (live) или AI (robot)
     * @type {string}
     * @memberof InterviewDetailItem
     */
    'interviewType'?: InterviewDetailItemInterviewType;
}

export const InterviewDetailItemInterviewType = {
    LIVE: 'live',
    AI: 'ai'
} as const;

export type InterviewDetailItemInterviewType = typeof InterviewDetailItemInterviewType[keyof typeof InterviewDetailItemInterviewType];

/**
 * Результат собеседования (Interview.Result)
 * @export
 * @enum {string}
 */

export const InterviewResultEnum = {
    SUCCESSFUL: 'SUCCESSFUL',
    UNSUCCESSFUL: 'UNSUCCESSFUL',
    ERROR: 'ERROR'
} as const;

export type InterviewResultEnum = typeof InterviewResultEnum[keyof typeof InterviewResultEnum];


/**
 * Статус собеседования (Interview.Status)
 * @export
 * @enum {string}
 */

export const InterviewStatusEnum = {
    NOT_STARTED: 'NOT_STARTED',
    IN_PROGRESS: 'IN_PROGRESS',
    FINISHED: 'FINISHED'
} as const;

export type InterviewStatusEnum = typeof InterviewStatusEnum[keyof typeof InterviewStatusEnum];


/**
 * 
 * @export
 * @interface OverviewStats
 */
export interface OverviewStats {
    /**
     * Всего кандидатов (количество уникальных email в Interview)
     * @type {number}
     * @memberof OverviewStats
     */
    'totalCandidates': number;
    /**
     * Средний балл (aiScore) по всем завершенным собеседованиям
     * @type {number}
     * @memberof OverviewStats
     */
    'avgRating': number;
    /**
     * Активных вакансий (Position.status = ACTIVE)
     * @type {number}
     * @memberof OverviewStats
     */
    'activePositions': number;
    /**
     * 
     * @type {OverviewStatsStatusDistribution}
     * @memberof OverviewStats
     */
    'statusDistribution': OverviewStatsStatusDistribution;
}
/**
 * Распределение по статусам для UI
 * @export
 * @interface OverviewStatsStatusDistribution
 */
export interface OverviewStatsStatusDistribution {
    /**
     * Успешные собеседования (Interview.result = SUCCESSFUL)
     * @type {number}
     * @memberof OverviewStatsStatusDistribution
     */
    'successful'?: number;
    /**
     * Собеседования в процессе (Interview.status = IN_PROGRESS)
     * @type {number}
     * @memberof OverviewStatsStatusDistribution
     */
    'inProgress'?: number;
    /**
     * Провальные собеседования (Interview.result = UNSUCCESSFUL + ERROR)
     * @type {number}
     * @memberof OverviewStatsStatusDistribution
     */
    'failed'?: number;
}
/**
 * Уровень позиции (Position.Level)
 * @export
 * @enum {string}
 */

export const PositionLevelEnum = {
    JUNIOR: 'JUNIOR',
    MIDDLE: 'MIDDLE',
    SENIOR: 'SENIOR',
    LEAD: 'LEAD'
} as const;

export type PositionLevelEnum = typeof PositionLevelEnum[keyof typeof PositionLevelEnum];


/**
 * Статус вакансии (Position.Status)
 * @export
 * @enum {string}
 */

export const PositionStatusEnum = {
    ACTIVE: 'ACTIVE',
    PAUSED: 'PAUSED',
    ARCHIVED: 'ARCHIVED'
} as const;

export type PositionStatusEnum = typeof PositionStatusEnum[keyof typeof PositionStatusEnum];


/**
 * 
 * @export
 * @interface RecruiterDetailItem
 */
export interface RecruiterDetailItem {
    /**
     * ID рекрутера (Account.id)
     * @type {number}
     * @memberof RecruiterDetailItem
     */
    'id': number;
    /**
     * Полное имя рекрутера (Account.firstName + lastName)
     * @type {string}
     * @memberof RecruiterDetailItem
     */
    'name': string;
    /**
     * Email рекрутера
     * @type {string}
     * @memberof RecruiterDetailItem
     */
    'email': string;
    /**
     * Общее количество созданных собеседований (Interview.createdBy = this)
     * @type {number}
     * @memberof RecruiterDetailItem
     */
    'volume': number;
    /**
     * Завершенные собеседования (Interview.status = FINISHED)
     * @type {number}
     * @memberof RecruiterDetailItem
     */
    'completed': number;
    /**
     * Процент успешных собеседований (SUCCESSFUL / FINISHED * 100)
     * @type {number}
     * @memberof RecruiterDetailItem
     */
    'successRate': number;
    /**
     * Средний балл (aiScore) по завершенным собеседованиям
     * @type {number}
     * @memberof RecruiterDetailItem
     */
    'quality': number;
    /**
     * Собеседования в работе (Interview.status = IN_PROGRESS)
     * @type {number}
     * @memberof RecruiterDetailItem
     */
    'inWork': number;
    /**
     * Количество активных позиций, созданных рекрутером
     * @type {number}
     * @memberof RecruiterDetailItem
     */
    'activePositions'?: number;
    /**
     * Название команды рекрутера (если есть)
     * @type {string}
     * @memberof RecruiterDetailItem
     */
    'teamName'?: string;
}
/**
 * Статус собеседования для UI (маппинг из Interview.status и Interview.result)
 * @export
 * @enum {string}
 */

export const StatisticsInterviewStatusEnum = {
    SCHEDULED: 'scheduled',
    SUCCESSFUL: 'successful',
    IN_PROGRESS: 'in-progress',
    FAILED: 'failed'
} as const;

export type StatisticsInterviewStatusEnum = typeof StatisticsInterviewStatusEnum[keyof typeof StatisticsInterviewStatusEnum];


/**
 * Период для фильтрации статистических данных
 * @export
 * @enum {string}
 */

export const StatisticsPeriod = {
    WEEK: 'week',
    MONTH: 'month',
    QUARTER: 'quarter',
    YEAR: 'year',
    ALL: 'all'
} as const;

export type StatisticsPeriod = typeof StatisticsPeriod[keyof typeof StatisticsPeriod];



/**
 * StatisticsApi - axios parameter creator
 * @export
 */
export const StatisticsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Данные для графика активности
         * @summary Активность по дням
         * @param {StatisticsPeriod} period Период для графика (неделя или месяц)
         * @param {number} [positionId] Необязательный фильтр по ID вакансии. Если указан — активность только по этой вакансии.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActivityStats: async (period: StatisticsPeriod, positionId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'period' is not null or undefined
            assertParamExists('getActivityStats', 'period', period)
            const localVarPath = `/stats/activity`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AdminAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (period !== undefined) {
                localVarQueryParameter['period'] = period;
            }

            if (positionId !== undefined) {
                localVarQueryParameter['positionId'] = positionId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Таблица собеседований с фильтрацией и пагинацией
         * @summary Детальная таблица собеседований
         * @param {StatisticsPeriod} period Период для фильтрации данных
         * @param {StatisticsInterviewStatusEnum} [status] Фильтр по статусу собеседования (для UI)
         * @param {string} [search] Поиск по кандидату или вакансии
         * @param {number} [positionId] Фильтр по ID вакансии
         * @param {number} [page] Номер страницы
         * @param {number} [size] Размер страницы
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInterviewDetails: async (period: StatisticsPeriod, status?: StatisticsInterviewStatusEnum, search?: string, positionId?: number, page?: number, size?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'period' is not null or undefined
            assertParamExists('getInterviewDetails', 'period', period)
            const localVarPath = `/stats/interviews`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AdminAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (period !== undefined) {
                localVarQueryParameter['period'] = period;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (positionId !== undefined) {
                localVarQueryParameter['positionId'] = positionId;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Статистические карточки и распределение по статусам
         * @summary Общая статистика
         * @param {StatisticsPeriod} period Период для фильтрации данных
         * @param {number} [positionId] Необязательный фильтр по ID вакансии. Если указан — статистика только по этой вакансии.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOverviewStats: async (period: StatisticsPeriod, positionId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'period' is not null or undefined
            assertParamExists('getOverviewStats', 'period', period)
            const localVarPath = `/stats/overview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AdminAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (period !== undefined) {
                localVarQueryParameter['period'] = period;
            }

            if (positionId !== undefined) {
                localVarQueryParameter['positionId'] = positionId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Таблица эффективности рекрутеров
         * @summary Эффективность рекрутеров
         * @param {StatisticsPeriod} period Период для фильтрации данных
         * @param {number} [positionId] Необязательный фильтр по ID вакансии. Если указан — метрики только по этой вакансии.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecruiterStats: async (period: StatisticsPeriod, positionId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'period' is not null or undefined
            assertParamExists('getRecruiterStats', 'period', period)
            const localVarPath = `/stats/recruiters`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AdminAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (period !== undefined) {
                localVarQueryParameter['period'] = period;
            }

            if (positionId !== undefined) {
                localVarQueryParameter['positionId'] = positionId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Возвращает кандидатов, прошедших итоговый отбор по вакансии/компании. Правило фильтрации (TASKNEIROKLYUCH-792): - AI: Interview.status = FINISHED, result = SUCCESSFUL,   aiScore >= Position.minScore (или DEFAULT_MIN_SCORE). - Live: InterviewSlot.status IN (APPROVED, COMPLETED) — берётся из ai-recruiter-back. Кандидаты со статусами REJECTED/CANCELLED/NO_SHOW/UNSUCCESSFUL/ERROR не возвращаются. 
         * @summary Итоги Подбора — только одобренные кандидаты
         * @param {StatisticsPeriod} [period] Период для фильтрации данных
         * @param {string} [search] Поиск по кандидату или вакансии
         * @param {number} [positionId] Фильтр по ID вакансии
         * @param {number} [page] Номер страницы
         * @param {number} [size] Размер страницы
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecruitmentResults: async (period?: StatisticsPeriod, search?: string, positionId?: number, page?: number, size?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/stats/results`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AdminAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (period !== undefined) {
                localVarQueryParameter['period'] = period;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (positionId !== undefined) {
                localVarQueryParameter['positionId'] = positionId;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StatisticsApi - functional programming interface
 * @export
 */
export const StatisticsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StatisticsApiAxiosParamCreator(configuration)
    return {
        /**
         * Данные для графика активности
         * @summary Активность по дням
         * @param {StatisticsPeriod} period Период для графика (неделя или месяц)
         * @param {number} [positionId] Необязательный фильтр по ID вакансии. Если указан — активность только по этой вакансии.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getActivityStats(period: StatisticsPeriod, positionId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ActivityByDay>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getActivityStats(period, positionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StatisticsApi.getActivityStats']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Таблица собеседований с фильтрацией и пагинацией
         * @summary Детальная таблица собеседований
         * @param {StatisticsPeriod} period Период для фильтрации данных
         * @param {StatisticsInterviewStatusEnum} [status] Фильтр по статусу собеседования (для UI)
         * @param {string} [search] Поиск по кандидату или вакансии
         * @param {number} [positionId] Фильтр по ID вакансии
         * @param {number} [page] Номер страницы
         * @param {number} [size] Размер страницы
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInterviewDetails(period: StatisticsPeriod, status?: StatisticsInterviewStatusEnum, search?: string, positionId?: number, page?: number, size?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<InterviewDetailItem>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInterviewDetails(period, status, search, positionId, page, size, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StatisticsApi.getInterviewDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Статистические карточки и распределение по статусам
         * @summary Общая статистика
         * @param {StatisticsPeriod} period Период для фильтрации данных
         * @param {number} [positionId] Необязательный фильтр по ID вакансии. Если указан — статистика только по этой вакансии.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOverviewStats(period: StatisticsPeriod, positionId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OverviewStats>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOverviewStats(period, positionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StatisticsApi.getOverviewStats']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Таблица эффективности рекрутеров
         * @summary Эффективность рекрутеров
         * @param {StatisticsPeriod} period Период для фильтрации данных
         * @param {number} [positionId] Необязательный фильтр по ID вакансии. Если указан — метрики только по этой вакансии.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRecruiterStats(period: StatisticsPeriod, positionId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RecruiterDetailItem>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRecruiterStats(period, positionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StatisticsApi.getRecruiterStats']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Возвращает кандидатов, прошедших итоговый отбор по вакансии/компании. Правило фильтрации (TASKNEIROKLYUCH-792): - AI: Interview.status = FINISHED, result = SUCCESSFUL,   aiScore >= Position.minScore (или DEFAULT_MIN_SCORE). - Live: InterviewSlot.status IN (APPROVED, COMPLETED) — берётся из ai-recruiter-back. Кандидаты со статусами REJECTED/CANCELLED/NO_SHOW/UNSUCCESSFUL/ERROR не возвращаются. 
         * @summary Итоги Подбора — только одобренные кандидаты
         * @param {StatisticsPeriod} [period] Период для фильтрации данных
         * @param {string} [search] Поиск по кандидату или вакансии
         * @param {number} [positionId] Фильтр по ID вакансии
         * @param {number} [page] Номер страницы
         * @param {number} [size] Размер страницы
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRecruitmentResults(period?: StatisticsPeriod, search?: string, positionId?: number, page?: number, size?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<InterviewDetailItem>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRecruitmentResults(period, search, positionId, page, size, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StatisticsApi.getRecruitmentResults']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * StatisticsApi - factory interface
 * @export
 */
export const StatisticsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StatisticsApiFp(configuration)
    return {
        /**
         * Данные для графика активности
         * @summary Активность по дням
         * @param {StatisticsPeriod} period Период для графика (неделя или месяц)
         * @param {number} [positionId] Необязательный фильтр по ID вакансии. Если указан — активность только по этой вакансии.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActivityStats(period: StatisticsPeriod, positionId?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<ActivityByDay>> {
            return localVarFp.getActivityStats(period, positionId, options).then((request) => request(axios, basePath));
        },
        /**
         * Таблица собеседований с фильтрацией и пагинацией
         * @summary Детальная таблица собеседований
         * @param {StatisticsPeriod} period Период для фильтрации данных
         * @param {StatisticsInterviewStatusEnum} [status] Фильтр по статусу собеседования (для UI)
         * @param {string} [search] Поиск по кандидату или вакансии
         * @param {number} [positionId] Фильтр по ID вакансии
         * @param {number} [page] Номер страницы
         * @param {number} [size] Размер страницы
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInterviewDetails(period: StatisticsPeriod, status?: StatisticsInterviewStatusEnum, search?: string, positionId?: number, page?: number, size?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<InterviewDetailItem>> {
            return localVarFp.getInterviewDetails(period, status, search, positionId, page, size, options).then((request) => request(axios, basePath));
        },
        /**
         * Статистические карточки и распределение по статусам
         * @summary Общая статистика
         * @param {StatisticsPeriod} period Период для фильтрации данных
         * @param {number} [positionId] Необязательный фильтр по ID вакансии. Если указан — статистика только по этой вакансии.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOverviewStats(period: StatisticsPeriod, positionId?: number, options?: RawAxiosRequestConfig): AxiosPromise<OverviewStats> {
            return localVarFp.getOverviewStats(period, positionId, options).then((request) => request(axios, basePath));
        },
        /**
         * Таблица эффективности рекрутеров
         * @summary Эффективность рекрутеров
         * @param {StatisticsPeriod} period Период для фильтрации данных
         * @param {number} [positionId] Необязательный фильтр по ID вакансии. Если указан — метрики только по этой вакансии.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecruiterStats(period: StatisticsPeriod, positionId?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<RecruiterDetailItem>> {
            return localVarFp.getRecruiterStats(period, positionId, options).then((request) => request(axios, basePath));
        },
        /**
         * Возвращает кандидатов, прошедших итоговый отбор по вакансии/компании. Правило фильтрации (TASKNEIROKLYUCH-792): - AI: Interview.status = FINISHED, result = SUCCESSFUL,   aiScore >= Position.minScore (или DEFAULT_MIN_SCORE). - Live: InterviewSlot.status IN (APPROVED, COMPLETED) — берётся из ai-recruiter-back. Кандидаты со статусами REJECTED/CANCELLED/NO_SHOW/UNSUCCESSFUL/ERROR не возвращаются. 
         * @summary Итоги Подбора — только одобренные кандидаты
         * @param {StatisticsPeriod} [period] Период для фильтрации данных
         * @param {string} [search] Поиск по кандидату или вакансии
         * @param {number} [positionId] Фильтр по ID вакансии
         * @param {number} [page] Номер страницы
         * @param {number} [size] Размер страницы
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecruitmentResults(period?: StatisticsPeriod, search?: string, positionId?: number, page?: number, size?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<InterviewDetailItem>> {
            return localVarFp.getRecruitmentResults(period, search, positionId, page, size, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * StatisticsApi - object-oriented interface
 * @export
 * @class StatisticsApi
 * @extends {BaseAPI}
 */
export class StatisticsApi extends BaseAPI {
    /**
     * Данные для графика активности
     * @summary Активность по дням
     * @param {StatisticsPeriod} period Период для графика (неделя или месяц)
     * @param {number} [positionId] Необязательный фильтр по ID вакансии. Если указан — активность только по этой вакансии.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatisticsApi
     */
    public getActivityStats(period: StatisticsPeriod, positionId?: number, options?: RawAxiosRequestConfig) {
        return StatisticsApiFp(this.configuration).getActivityStats(period, positionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Таблица собеседований с фильтрацией и пагинацией
     * @summary Детальная таблица собеседований
     * @param {StatisticsPeriod} period Период для фильтрации данных
     * @param {StatisticsInterviewStatusEnum} [status] Фильтр по статусу собеседования (для UI)
     * @param {string} [search] Поиск по кандидату или вакансии
     * @param {number} [positionId] Фильтр по ID вакансии
     * @param {number} [page] Номер страницы
     * @param {number} [size] Размер страницы
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatisticsApi
     */
    public getInterviewDetails(period: StatisticsPeriod, status?: StatisticsInterviewStatusEnum, search?: string, positionId?: number, page?: number, size?: number, options?: RawAxiosRequestConfig) {
        return StatisticsApiFp(this.configuration).getInterviewDetails(period, status, search, positionId, page, size, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Статистические карточки и распределение по статусам
     * @summary Общая статистика
     * @param {StatisticsPeriod} period Период для фильтрации данных
     * @param {number} [positionId] Необязательный фильтр по ID вакансии. Если указан — статистика только по этой вакансии.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatisticsApi
     */
    public getOverviewStats(period: StatisticsPeriod, positionId?: number, options?: RawAxiosRequestConfig) {
        return StatisticsApiFp(this.configuration).getOverviewStats(period, positionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Таблица эффективности рекрутеров
     * @summary Эффективность рекрутеров
     * @param {StatisticsPeriod} period Период для фильтрации данных
     * @param {number} [positionId] Необязательный фильтр по ID вакансии. Если указан — метрики только по этой вакансии.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatisticsApi
     */
    public getRecruiterStats(period: StatisticsPeriod, positionId?: number, options?: RawAxiosRequestConfig) {
        return StatisticsApiFp(this.configuration).getRecruiterStats(period, positionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Возвращает кандидатов, прошедших итоговый отбор по вакансии/компании. Правило фильтрации (TASKNEIROKLYUCH-792): - AI: Interview.status = FINISHED, result = SUCCESSFUL,   aiScore >= Position.minScore (или DEFAULT_MIN_SCORE). - Live: InterviewSlot.status IN (APPROVED, COMPLETED) — берётся из ai-recruiter-back. Кандидаты со статусами REJECTED/CANCELLED/NO_SHOW/UNSUCCESSFUL/ERROR не возвращаются. 
     * @summary Итоги Подбора — только одобренные кандидаты
     * @param {StatisticsPeriod} [period] Период для фильтрации данных
     * @param {string} [search] Поиск по кандидату или вакансии
     * @param {number} [positionId] Фильтр по ID вакансии
     * @param {number} [page] Номер страницы
     * @param {number} [size] Размер страницы
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatisticsApi
     */
    public getRecruitmentResults(period?: StatisticsPeriod, search?: string, positionId?: number, page?: number, size?: number, options?: RawAxiosRequestConfig) {
        return StatisticsApiFp(this.configuration).getRecruitmentResults(period, search, positionId, page, size, options).then((request) => request(this.axios, this.basePath));
    }
}



